module.exports = __webpack_public_path__ + "static/media/oneb.b1205ae7.svg";